import FETCH from "../utils/fetch";
import ROUTES from "../config/routes";

const fetchAllBudget = async (startDate, endDate, category) => {
  let res = await FETCH.get({
    url: `${ROUTES.GET_ALL_BUDGETS}?startDate=${startDate}&endDate=${endDate}&category=${category}`,
  });
  return res;
};
const fetchAllTransactionCatgoires = async () => {
  let res = await FETCH.get({
    url: `${ROUTES.GET_ALL_TRANSACTION_CATEGORIES}`,
  });
  return res;
};

const fetchAllTransactionSubCatgoires = async () => {
  let res = await FETCH.get({
    url: `${ROUTES.GET_ALL_TRANSACTION_SUB_CATEGORIES}`,
  });
  return res;
};


const updateAllTransactionCategoires = async (body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.GET_ALL_TRANSACTION_CATEGORIES}`,
    body,
  });
  return res;
};

const updateAllTransactionSubCategoires = async (body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.GET_ALL_TRANSACTION_SUB_CATEGORIES}`,
    body,
  });
  return res;
};
const fetchAllTransaction = async (page,limit) => {
  let res = await FETCH.get({
    url: `${ROUTES.GET_ALL_TRANSACTIONS}?page=${page}&limit=${limit}`,
  });
  return res;
};
const getCalculatedBudgetTransactions = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.CALCULATED_BUDGET_TRANSACTIONS}`,
    body,
  });
  return res;
};
const addRecurringToken = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.RECURRING_TOKEN}`,
    body,
  });
  return res;
};
const fetchRecurringToken = async (page) => {
  let res = await FETCH.get({
    url: `${ROUTES.RECURRING_TOKEN}?page=${page}&limit=10`,
  });
  return res;
};
const updateRecurringToken = async (body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.RECURRING_TOKEN}`,
    body,
  });
  return res;
};
const updateRecurringTokenPattren = async (body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.RECURRING_TOKEN_UPDATE}`,
    body,
  });
  return res;
};
const fetchSystemRecurringTransactions = async (page) => {
  let res = await FETCH.get({
    url: `${ROUTES.SYSTEM_RECURRING_TRANSACTIONS}?page=${page}&limit=10`,
  });
  return res;
};
const updateMonthlyBudget = async (body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.UPADTE_MONTHLY_BUDGET}`,
    body,
  });
  return res;
};
const fetchFilterTransaction = async (queryParam) => {
  let res = await FETCH.get({
    url: `${ROUTES.GET_FILTER_TRANSACTIONS}?${queryParam}`,
  });
  return res;
};
const deleteRecurringToken = async (id) => {
  let res = await FETCH.deletee({
    url: `${ROUTES.RECURRING_TOKEN}`,
    body:id
  });
  return res;
};
const deleteRecurringTokenPattern = async (id) => {
  let res = await FETCH.deletee({
    url: `${ROUTES.RECURRING_TOKEN_UPDATE}`,
    body:id
  });
  return res;
};
const addRecurringTokenPattren = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.RECURRING_TOKEN_UPDATE}`,
    body,
  });
  return res;
};

const addTransactionRule = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.TRANSACTIONS_RULE}`,
    body,
  });
  return res;
};
const updateTransactionRule = async (body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.TRANSACTIONS_RULE}`,
    body,
  });
  return res;
};
const deleteTransactionRule = async (id) => {
  let res = await FETCH.deletee({
    url: `${ROUTES.TRANSACTIONS_RULE}?id=${id}`,
    body:id
  });
  return res;
};
const fetchTransactionsRules = async (page) => {
  let res = await FETCH.get({
    url: `${ROUTES.TRANSACTIONS_RULE}?page=${page}&limit=10`,
  });
  return res;
};
const updatePreviousTransactionsForRecurring = async (tokenId,patternId) => {
  let res = await FETCH.post({
    url: patternId ? `${ROUTES.PAST_RECURRING}?tokenId=${tokenId}&patternId=${patternId}` : `${ROUTES.PAST_RECURRING}?tokenId=${tokenId}` ,
    body: {},
  });
  return res;
};
const fetchAllRuleBasedTransaction = async (ruleId) => {
  let res = await FETCH.get({
    url: `${ROUTES.RULE_TRANSACTIONS}?ruleId=${ruleId}`,
  });
  return res;
};
const updateRuleBasedTransactions = async (body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.RULE_TRANSACTIONS}`,
    body,
  });
  return res;
};
const fetchRecurringAppliedTransaction = async (categoryId,page,limit) => {
  let res = await FETCH.get({
    url: `${ROUTES.RECURRING_CATEGORY_TRANSACTIONS}?categoryId=${categoryId}&page=${page}&limit=${limit}`,
  });
  return res;
};
const searchRecurringAppliedTransaction = async (page,limit,name) => {
  let res = await FETCH.get({
    url: `${ROUTES.SEARCH_RECURRING_CATEGORY_TRANSACTIONS}?page=${page}&limit=${limit}&name=${name}`,
  });
  return res;
};
const createTransactionsForRecurring = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.RECURRING_CATEGORY_TRANSACTIONS_CREATE}` ,
    body,
  });
  return res;
};

const BUDGET_API = {
  fetchAllBudget,
  fetchAllTransactionCatgoires,
  fetchAllTransactionSubCatgoires,
  updateAllTransactionCategoires,
  updateAllTransactionSubCategoires,
  fetchAllTransaction,
  getCalculatedBudgetTransactions,
  addRecurringToken,
  fetchRecurringToken,
  updateRecurringToken,
  updateRecurringTokenPattren,
  fetchSystemRecurringTransactions,
  updateMonthlyBudget,
  fetchFilterTransaction,
  deleteRecurringToken,
  deleteRecurringTokenPattern,
  addRecurringTokenPattren,
  addTransactionRule,
  updateTransactionRule,
  deleteTransactionRule,
  fetchTransactionsRules,
  updatePreviousTransactionsForRecurring,
  fetchAllRuleBasedTransaction,
  updateRuleBasedTransactions,
  fetchRecurringAppliedTransaction,
  searchRecurringAppliedTransaction,
  createTransactionsForRecurring
};
export default BUDGET_API;
